// lussana.me frontend

import React, { useEffect, useState } from "react";
import './App.css';
import 'photoswipe/dist/photoswipe.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoadingProvider, useLoading } from "./contexts/LoadingContext";
import { CookieConsentProvider, useCookieConsent } from "./contexts/CookieConsentContext";

import StrapiHealthCheck from "./components/StrapiHealthCheck";
import NavbarComponent from "./components/navbar";
import FooterComponent from "./components/footer";
import CookieConsentOffcanvas from "./components/CookieConsent/CookieConsentOffcanvas";
import RightClickProtection from "./components/RightClickProtection";

import Home from "./pages/home/home";
import AboutMe from "./pages/about-me/about-me";
import Contact from "./pages/contacts/contacts";
import Newsletter from "./pages/newsletter/newsletter";

import ExpoQR from "./pages/expo/expoQR";
import ExpoFeedback from "./pages/expo/feedback";


import PrivacyPolicy from "./pages/privacy-policy/privacy-policy";
import TermsOfUse from "./pages/terms-of-use/terms-of-use";

import Kitchen from "./pages/kitchen/kitchen";
import Recipe from "./pages/kitchen/recipe";
import RecipeNotFound from "./pages/NotFound/NotFound";

import Photos from "./pages/photos/photos";
import Project from "./pages/photos/project";
import ProjectNotFound from "./pages/NotFound/NotFound";

import Events from "./pages/events/events";
import Event from "./pages/events/event";
import EventsNotFound from "./pages/NotFound/NotFound";

import Officina from "./pages/officina/officina";
import OfficinaProduct from "./pages/officina/product";
import OfficinaNotFound from "./pages/NotFound/NotFound";

import CoaS from "./pages/coa/coa";
import Coa from "./pages/coa/print";
import CoaNotFound from "./pages/NotFound/NotFound";

import NotFound from "./pages/NotFound/NotFound";

import i18n from "./i18n/i18n";


function TranslationGate({ children }) {
  const { setIsLoading } = useLoading();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    const tryToResolve = () => {
      const isReady = i18n.isInitialized && i18n.hasResourceBundle(i18n.language, 'translation');
      if (isReady) {
        setIsLoading(false);
        setReady(true);
      }
    };

    const onInitialized = () => {
      i18n.loadLanguages(i18n.language).then(tryToResolve);
    };

    const onLoaded = () => {
      tryToResolve();
    };

    if (i18n.isInitialized) {
      onLoaded();
    } else {
      i18n.on('initialized', onInitialized);
    }

    i18n.on('loaded', onLoaded);

    return () => {
      i18n.off('initialized', onInitialized);
      i18n.off('loaded', onLoaded);
    };
  }, [setIsLoading]);

  return ready ? children : null;
}

function AppContent() {
  const { showConsent, setShowConsent } = useCookieConsent();

  return (
    <>
      <CookieConsentOffcanvas open={showConsent} onClose={() => setShowConsent(false)} />
      <Router>
        <RightClickProtection />
        <NavbarComponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contacts" element={<Contact />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
			  
          <Route path="/expo" element={<ExpoQR />} />
          <Route path="/expo/feedback" element={<ExpoFeedback />} />
			  

          <Route path="/photos" element={<Photos />} />
          <Route path="/photos/:slug" element={<Project />} />
          <Route path="/photos/*" element={<ProjectNotFound />} />

          <Route path="/kitchen" element={<Kitchen />} />
          <Route path="/kitchen/:slug" element={<Recipe />} />
          <Route path="/kitchen/*" element={<RecipeNotFound />} />

          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<Event />} />
          <Route path="/events/*" element={<EventsNotFound />} />

          <Route path="/officina" element={<Officina />} />
          <Route path="/officina/:slug" element={<OfficinaProduct />} />
          <Route path="/officina/*" element={<OfficinaNotFound />} />
			  
          <Route path="/coa" element={<CoaS />} />
          <Route path="/coa/:documentId" element={<Coa />} />
          <Route path="/coa/*" element={<CoaNotFound />} />
			 
			  
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FooterComponent />
      </Router>
    </>
  );
}

// ✅ Bootstrap
function App() {
  return (
    <StrapiHealthCheck>
      <LoadingProvider>
        <CookieConsentProvider>
          <TranslationGate>
            <AppContent />
          </TranslationGate>
        </CookieConsentProvider>
      </LoadingProvider>
    </StrapiHealthCheck>
  );
}

export default App;
